import { AccommodationReviewsState } from '../../../routes/reducers/types';

import {
  RESET_ACCOMMODATION_REVIEWS,
  FETCH_ACCOMMODATION_REVIEWS_SUCCESS,
  FETCH_ACCOMMODATION_REVIEWS_PAGINATION_REQUEST,
  FETCH_ACCOMMODATION_REVIEWS_PAGINATION_SUCCESS,
  FETCH_ACCOMMODATION_REVIEWS_PAGINATION_FAILURE,
} from '../actions';
import { AccommodationReviews } from '../types';

const initialState: AccommodationReviewsState = {
  loading: false,
};

// This is how the accommodationReviewState should look like
//
// const accommodationReviewState = {
//   loading: false,
//   pagination: {
//     totalEntries: 12,
//     currentPage: 1,
//     totalPages: 2,
//     offset: 0,
//   },
//   avgRatings: {
//     avgRatingOverall: 5.0,
//     avgRatingArea: 5.0,
//     avgRatingComfort: 5.0,
//     avgRatingValue: 5.0,
//     avgRatingCleanliness: 5.0,
//   },
//   reviews: [
//     {
//       id: 12,
//       nps: 9.0,
//       comment: {
//         id: 12,
//         userName: 'Firstname',
//         comment: 'A comment',
//         commentDate: new Date(2021, 10, 7),
//       },
//     },
//   ],
// };

function addLoadedReviewsToState(
  state: AccommodationReviewsState,
  payload: AccommodationReviews,
): AccommodationReviewsState {
  const newState = { ...state };
  newState.pagination = {
    totalEntries: payload.pagination.totalEntries,
    currentPage: payload.pagination.currentPage,
    totalPages: payload.pagination.totalPages,
    offset: payload.pagination.offset,
  };
  newState.avgRatings = {
    avgRatingOverall: payload.avgRatingOverall,
    avgRatingArea: payload.avgRatingArea,
    avgRatingComfort: payload.avgRatingComfort,
    avgRatingValue: payload.avgRatingValue,
    avgRatingCleanliness: payload.avgRatingCleanliness,
  };
  if (state.reviews && state.reviews.length === 0 && payload.pagination.currentPage === 1) {
    newState.reviews = payload.reviews;
  } else {
    newState.reviews = payload.reviews;
  }
  return newState;
}

function addPaginatedReviewsToState(
  state: AccommodationReviewsState,
  payload: AccommodationReviews,
): AccommodationReviewsState {
  const newState = {
    ...state,
    loading: false,
  };

  // only append new reviews if the loaded page is the one that follows the current page
  if (state.pagination && payload.pagination.currentPage !== state.pagination.currentPage + 1) {
    return newState;
  }

  newState.pagination = {
    totalEntries: payload.pagination.totalEntries,
    currentPage: payload.pagination.currentPage,
    totalPages: payload.pagination.totalPages,
    offset: payload.pagination.offset,
  };
  const existingReviews = state.reviews || [];
  newState.reviews = [...existingReviews, ...payload.reviews];
  return newState;
}

export default (
  state: AccommodationReviewsState = initialState,
  action: any,
): AccommodationReviewsState => {
  switch (action.type) {
    case RESET_ACCOMMODATION_REVIEWS:
      return initialState;
    case FETCH_ACCOMMODATION_REVIEWS_SUCCESS:
      return addLoadedReviewsToState(state, action.payload);
    case FETCH_ACCOMMODATION_REVIEWS_PAGINATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ACCOMMODATION_REVIEWS_PAGINATION_SUCCESS: {
      return addPaginatedReviewsToState(state, action.payload);
    }
    case FETCH_ACCOMMODATION_REVIEWS_PAGINATION_FAILURE:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};
